"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClosingCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="closing-cta" className="relative py-24 lg:py-32 bg-gradient-to-b from-secondary to-[#0F1B2D] overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[800px] h-[800px] bg-primary/5 rounded-lg blur-3xl" />
      </div>

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-white mb-6 tracking-tight">
          Configure a Product or Upload Your File
        </h2>
        
        <p className="text-lg md:text-xl text-zinc-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          Tell Evermark Industrial Solutions what you need engraved — material, size, and quantity — and get a quote with a proof before production.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 shadow-lg shadow-black/20">
            <Link to="/ContactPage">Request a Quote</Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 border-2 border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground shadow-lg shadow-black/20 transition-colors">
            
          </Button>
        </div>
      </div>
    </section>;
}